<div class="row justify-content-center" [ngClass]="routeAnimationsElements">
  <mat-card>
    <rpe-rol-detail [formInput]=formInput.rolDetailFormInput></rpe-rol-detail>

    <div class="flex" [ngClass]="routeAnimationsElements">

      <button class="button" *ngIf=formInput.verBotonRechazar [ngClass]="routeAnimationsElements" type="button"
        mat-raised-button color="warn" (click)="onRechazar()">
        {{ 'rpe.vista-usuario.rechazar' | translate }}
      </button>

      <!-- <button class="button" *ngIf=formInput.verBotonSeleccionarActividad [ngClass]="routeAnimationsElements"
        type="button" mat-raised-button color="primary" (click)="onSeleccionarActividad()">
        {{ 'rpe.vista-usuario.seleccionar-actividad' | translate }}
      </button> -->

      <div>
        <button class="button" *ngIf=formInput.verBotonConfirmar [ngClass]="routeAnimationsElements" type="button"
          mat-raised-button color="primary" (click)="onConfirmar()" [disabled]="(isLoading$ | async)">
          {{ 'Aceptar y continuar' }}
        </button>
      </div>

      <button class="button" *ngIf=formInput.verBotonDesvincularse [ngClass]="routeAnimationsElements" type="button"
        mat-raised-button color="warn" (click)="onDesvicularse()">
        {{ 'rpe.vista-usuario.desvincularse' | translate }}
      </button>
    </div>
  </mat-card>
</div>